import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-page px-6 text-center">
      <div>
        <div className="font-mono text-sm text-brand-deep">404</div>
        <h1 className="mt-2 font-sans text-2xl font-bold tracking-tight text-fg">Page not found</h1>
        <Link
          to="/dashboard/store"
          className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand-deep"
        >
          Back to catalog <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
